<ng-template #surveyFormTemplateRef>
  <form [formGroup]="form">
    <app-select
      [control]="form.controls.selectedSiteId"
      [items]="surveySites"
      [optionTemplateName]="'site-icon'"
      labelKey="satisfaction-surveys/copy/account">
    </app-select>
    <mat-form-field>
      <mat-label translate="satisfaction-surveys/copy/name"> </mat-label>
      <input type="text" matInput formControlName="surveyName" />
      <mat-error
        translate="common/form_errors/required"
        *ngIf="form.get('surveyName').hasError('required')"></mat-error>
    </mat-form-field>

    <p translate="quick-replies/copy/name_already_exists" *ngIf="warningNameAlreadyExists"></p>
  </form>
</ng-template>
